import { Component } from '@angular/core';
import { CurrentEnvironmentService } from '@modules/common/services/current-environment.service';
import { EnvironmentListService } from '@modules/common/services/environment-list.service';

@Component({
    selector: 'app-nav-env-message',
    templateUrl: './nav-env-message.component.html',
    styleUrls: ['./nav-env-message.component.scss']
})
export class NavEnvMessageComponent {
    public environmentMessage?: string;

    constructor(
        private _environmentListService: EnvironmentListService,
        private _currentEnvironmentService: CurrentEnvironmentService
    ) {
        this._environmentListService.environmentListChanged.subscribe(() => this.updateEnvironmentMessage());
        this._currentEnvironmentService.environmentChanged.subscribe(() => this.updateEnvironmentMessage());
    }

    private updateEnvironmentMessage(): void {
        this.environmentMessage = undefined;
        const environmentName = this._currentEnvironmentService.getCurrentEnvironmentName();
        if (environmentName) {
            const environment = this._environmentListService.getEnvironmentList().filter(x => x.name.toLowerCase() == environmentName.toLowerCase())[0];

            if (environment && !environment.isDefault) {
                this.environmentMessage = environment.description;
            }
        }
    }
}